<script>
    import {post} from "./lib/Request.svelte";

    export let selectedUsers;
    export let selectUser;

    let username = null;
    let isLoading = false;
    let searchResults = [];
    let timer;
    let cancel;

    async function onInput(event) {
        clearTimeout(timer);
        console.log('clear', timer);

        if (cancel) {
            //return;
            isLoading = false;
            cancel();
        }

        timer = setTimeout(() => {
            console.log('set', timer);
            search(event);
        }, 1000);
    }

    async function search(event) {
        event.preventDefault();
        isLoading = true;

        try {
            const matches = username.match(/(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)/im);
            if (matches) {
                username = matches[1];
            }
        } catch (err) {
            console.log(err);
        }
        username = username.replace('@', '');
        username = `@${username}`;

        searchResults = [];
        searchResults = await searchUsers(username);
    }

    async function addRelation(item) {
        searchResults = [];
        selectUser(item);
    }

    async function searchUsers(query) {
        let result = [];
        await post('/instashpion/api/search', {
            query: query,
        })
            .then((response) => {
                if (response.status === 'ok') {
                    result = response.data;
                }
            })
            .catch(error => {
                console.log(error, error.response);
            });

        if (!cancel) {
            isLoading = false;
        }
        cancel = null;

        return result;
    }

    async function getInfo(username) {
        let result = {};
        await post('/instashpion/api/get-info', {
            username: username,
        })
            .then((response) => {
                if (response.status === 'ok') {
                    result = response.data;
                }
            })
            .catch(error => {
                console.log(error.response);
            });

        return result;
    }

</script>

<div class="instagram-search-wrap" >
    <form on:submit={search}>
        <div class="blockable__wrap position-relative">
            <span on:click={window.handleClickOnClickTarget} class="blockable__click-target"></span>
            <span class="blockable__message"></span>
            <input type="text"
                   id="search-account-input"
                   class="main__banner-input_item"
                   placeholder="@username"
                   name="search"
                   bind:value={username}
                   on:input={onInput}
            />
            <img src="/spy30-landing/assets/images/spinner.svg" alt="search" class={isLoading ? 'main__banner-spinner_icon' : 'hide'} />
        </div>
    </form>


        <ul class={searchResults.length > 0 ? 'results-container' : 'hide'}>
            {#each searchResults as item}
                <li on:click={addRelation(item)}>
                    <img src={item.photo} alt={item.name} class="avatar" />@{item.username}
                </li>
            {/each}
        </ul>
</div>

<style>
    .position-relative {
        position: relative;
    }
    .instagram-search-wrap {
        position: relative;
    }
    .error {
        color: red;
    }
    .mt-1 {
        margin-top: 1rem;
    }
    .mb-1 {
        margin-bottom: 1rem;
    }
    .results-container {
        display: block;
        position: absolute;
        top: calc(100% - 1px);
        padding: 0;
        list-style: none;
        width: 80%;
        margin: 0;
        border: 1px solid #ccc;
        z-index: 11;
        margin-top: 10px;
        text-align: left;

        left: 50%;
        transform: translateX(-50%);
    }
    .results-container li {
        background-color: grey;
        color: #fff;
        border-bottom: none;
        padding: 10px 20px;
        cursor: pointer;
        margin: 0;
    }
    .results-container li:hover {
        background-color: #009c42;
    }
    .results-container li img.avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
        box-sizing: border-box;
    }
    .main__banner-input_item {
        background: #F2F2F2;
        border: 1px solid #C4C4C4;
        border-radius: 5px;
        padding: 12px;
        height: 41px;
        width: 80%;
    }
    .main__banner-spinner_icon {
        height: 30px;
        position: absolute;
        top: 50%;
        right: 20%;
        transform: translateY(-50%);
    }
</style>